<template>
<div class="contracts">
  <b-table
    striped
    hover
    fixed
    Outlined
    show-empty
    :empty-text="'No data available'"
    :items="contracts"
    :fields="fields"
    table-class="list-table text-center"
    thead-class="list-table__head"
    tbody-class="list-table__body"
  >
    <template #cell(Detail)="contract">
      <b-button pill variant="outline-secondary" size="sm"
        style="min-width: 100%"
        :to="{
          name: 'TutorContract',
          params: {
            tutorId: tutor.id,
            contractId: contract.item.contractNumber,
          },
        }"
      >
        Detail
      </b-button>
    </template>
  </b-table>
</div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import _ from 'lodash'
import { Moment } from 'moment'
import { Contract, Tutor } from '@/store/tutors/types'
import { Position } from '@/store/master/types'

@Component
export default class TutorProfileContracts extends Vue {
  @Prop({ required: true }) tutor!: Tutor

  private fields = [
    {
      key: 'contractNumber',
      label: 'Contract No',
    },
    {
      key: 'from',
      label: 'Contract from',
      formatter: (date: Moment) => date.format('YYYY/MM/DD'),
    },
    {
      key: 'to',
      label: 'Contract to',
      formatter: (date: Moment|null) => date && date.format('YYYY/MM/DD'),
    },
    {
      key: 'position',
      label: 'Position',
      formatter: (position: Position) => position.name,
    },
    {
      key: 'Detail',
    },
  ]

  private get contracts(): Contract[] {
    return this.tutor.contracts
  }
}
</script>

<style>
.contracts .list-table__head {
  font-size: .8rem;
}
</style>
